import { Recommendation } from '@agroone/entities'
import { ActionCreator, createAction, props, Action } from '@ngrx/store'

export enum RecommendationActionTypes {
  LOAD_RECOMMENDATIONS = '[Recommendation] Load recommendations',
  LOAD_RECOMMENDATIONS_SUCCESS = '[Recommendation] Load recommendations Success',
  LOAD_RECOMMENDATIONS_FAILURE = '[Recommendation] Load recommendations Failure',

  ADD_RECOMMENDATION = '[Recommendation] Add recommendation',
  ADD_RECOMMENDATION_SUCCESS = '[Recommendation] Add recommendation Success',
  ADD_RECOMMENDATION_FAILURE = '[Recommendation] Add recommendation Failure',

  ADD_RECOMMENDATIONS = '[Recommendation] Add recommendations',
  ADD_RECOMMENDATIONS_SUCCESS = '[Recommendation] Add recommendations Success',
  ADD_RECOMMENDATIONS_FAILURE = '[Recommendation] Add recommendations Failure',

  DELETE_RECOMMENDATION_SUCCESS = '[Recommendation] Delete recommendation Success',
  DELETE_RECOMMENDATION_FAILURE = '[Recommendation] Delete recommendation Failure',
  DELETE_RECOMMENDATION = '[Recommendation] Delete Recommendation',
}

// LOAD RECOMMENDATIONS
export const loadRecommendations: ActionCreator<
  RecommendationActionTypes.LOAD_RECOMMENDATIONS,
  (props: { cropId: number }) => {
    cropId: number
  } & Action<RecommendationActionTypes.LOAD_RECOMMENDATIONS>
> = createAction(RecommendationActionTypes.LOAD_RECOMMENDATIONS, props<{ cropId: number }>())

export const loadRecommendationsSuccess: ActionCreator<
  RecommendationActionTypes.LOAD_RECOMMENDATIONS_SUCCESS,
  (props: { cropId: number; recommendations: Recommendation[] }) => {
    cropId: number
    recommendations: Recommendation[]
  } & Action<RecommendationActionTypes.LOAD_RECOMMENDATIONS_SUCCESS>
> = createAction(
  RecommendationActionTypes.LOAD_RECOMMENDATIONS_SUCCESS,
  props<{ cropId: number; recommendations: Recommendation[] }>(),
)

export const loadRecommendationsFailure: ActionCreator<
  RecommendationActionTypes.LOAD_RECOMMENDATIONS_FAILURE,
  (props: { error: unknown }) => {
    error: unknown
  } & Action<RecommendationActionTypes.LOAD_RECOMMENDATIONS_FAILURE>
> = createAction(RecommendationActionTypes.LOAD_RECOMMENDATIONS_FAILURE, props<{ error: unknown }>())

// LOAD Recommendation

// ADD Recommendation
export const addRecommendation: ActionCreator<
  RecommendationActionTypes.ADD_RECOMMENDATION,
  (props: {
    payload: {
      cropId: number
      recommendation: Recommendation
      pictures?: {
        name: string
        content: string
      }[]
    }
  }) => {
    payload: {
      cropId: number
      recommendation: Recommendation
      pictures?: {
        name: string
        content: string
      }[]
    }
  } & Action<RecommendationActionTypes.ADD_RECOMMENDATION>
> = createAction(
  RecommendationActionTypes.ADD_RECOMMENDATION,
  props<{
    payload: {
      cropId: number
      recommendation: Recommendation
      pictures?: { name: string; content: string }[]
    }
  }>(),
)

export const addRecommendationSuccess: ActionCreator<
  RecommendationActionTypes.ADD_RECOMMENDATION_SUCCESS,
  (props: {
    payload: {
      recommendations: Recommendation[]
    }
  }) => {
    payload: {
      recommendations: Recommendation[]
    }
  } & Action<RecommendationActionTypes.ADD_RECOMMENDATION_SUCCESS>
> = createAction(
  RecommendationActionTypes.ADD_RECOMMENDATION_SUCCESS,
  props<{
    payload: {
      recommendations: Recommendation[]
    }
  }>(),
)

export const addRecommendationFailure: ActionCreator<
  RecommendationActionTypes.ADD_RECOMMENDATION_FAILURE,
  (props: { error: unknown; loading?: boolean; message: string }) => {
    error: unknown
    loading?: boolean
    message: string
  } & Action<RecommendationActionTypes.ADD_RECOMMENDATION_FAILURE>
> = createAction(
  RecommendationActionTypes.ADD_RECOMMENDATION_FAILURE,
  props<{ error: unknown; loading?: boolean; message: string }>(),
)

// ADD Recommendations
export const addRecommendations: ActionCreator<
  RecommendationActionTypes.ADD_RECOMMENDATIONS,
  (props: {
    payload: {
      isMultiReco?: boolean
      recommendations: Recommendation[]
      pictures?: {
        name: string
        content: string
      }[]
    }
  }) => {
    payload: {
      isMultiReco?: boolean
      recommendations: Recommendation[]
      pictures?: {
        name: string
        content: string
      }[]
    }
  } & Action<RecommendationActionTypes.ADD_RECOMMENDATIONS>
> = createAction(
  RecommendationActionTypes.ADD_RECOMMENDATIONS,
  props<{
    payload: {
      isMultiReco?: boolean
      recommendations: Recommendation[]
      pictures?: { name: string; content: string }[]
    }
  }>(),
)

export const addRecommendationsSuccess: ActionCreator<
  RecommendationActionTypes.ADD_RECOMMENDATIONS_SUCCESS,
  (props: {
    payload: {
      recommendations: Recommendation[]
    }
  }) => {
    payload: {
      recommendations: Recommendation[]
    }
  } & Action<RecommendationActionTypes.ADD_RECOMMENDATIONS_SUCCESS>
> = createAction(
  RecommendationActionTypes.ADD_RECOMMENDATIONS_SUCCESS,
  props<{
    payload: {
      recommendations: Recommendation[]
    }
  }>(),
)

export const addRecommendationsFailure: ActionCreator<
  RecommendationActionTypes.ADD_RECOMMENDATIONS_FAILURE,
  (props: { error: unknown; loading?: boolean; message: string }) => {
    error: unknown
    loading?: boolean
    message: string
  } & Action<RecommendationActionTypes.ADD_RECOMMENDATIONS_FAILURE>
> = createAction(
  RecommendationActionTypes.ADD_RECOMMENDATIONS_FAILURE,
  props<{ error: unknown; loading?: boolean; message: string }>(),
)

// UPDATE Recommendation

export const deleteRecommendation: ActionCreator<
  RecommendationActionTypes.DELETE_RECOMMENDATION,
  (props: { cropId: number; recommendationId: number }) => {
    cropId: number
    recommendationId: number
  } & Action<RecommendationActionTypes.DELETE_RECOMMENDATION>
> = createAction(RecommendationActionTypes.DELETE_RECOMMENDATION, props<{ cropId: number; recommendationId: number }>())

export const deleteRecommendationSuccess: ActionCreator<
  RecommendationActionTypes.DELETE_RECOMMENDATION_SUCCESS,
  (props: { cropId: number; recommendationId: number }) => {
    cropId: number
    recommendationId: number
  } & Action<RecommendationActionTypes.DELETE_RECOMMENDATION_SUCCESS>
> = createAction(
  RecommendationActionTypes.DELETE_RECOMMENDATION_SUCCESS,
  props<{
    cropId: number
    recommendationId: number
  }>(),
)
export const deleteRecommendationError: ActionCreator<
  RecommendationActionTypes.DELETE_RECOMMENDATION_FAILURE,
  (props: { error: unknown }) => {
    error: unknown
  } & Action<RecommendationActionTypes.DELETE_RECOMMENDATION_FAILURE>
> = createAction(RecommendationActionTypes.DELETE_RECOMMENDATION_FAILURE, props<{ error: unknown }>())
